function tagsChanged(stateTags, incomingTags) {
  // Handle nullish inputs
  if (!stateTags || !incomingTags) {
    return true; // Consider nullish inputs as a change
  }

  for (const tag of incomingTags) {
    const existing = stateTags[tag.id];
    if (!existing) return true; // New tag
    // Shallow compare (customize as needed)
    for (const key in tag) {
      if (tag[key] !== existing[key]) return true;
    }
  }
  return false;
}

export default tagsChanged;
